type ChannelIdentity = {
  id: string | number;
};

/**
 * commerce kernel IDs may arrive as numbers at runtime even when generated dashboard
 * types model them as strings. Normalize only for identity comparison so store
 * selection cannot silently fail for multi-channel administrators.
 */
export function findChannelById<T extends ChannelIdentity>(
  channels: T[],
  channelId: string | number,
): T | undefined {
  return channels.find(
    (channel) => String(channel.id) === String(channelId),
  );
}
